import { Component } from '@angular/core';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';

@Component({
  selector: 'app-radiobutton',
  standalone: true,
  templateUrl: './radiobutton.component.html',
  styleUrls: [],
  imports: [ReactiveFormsModule, MatRadioGroup, MatRadioButton],
})
export class RadiobuttonComponent {
  field: Fields;
  group: UntypedFormGroup;
  requiredBool: boolean;
}
